var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import sortBy from 'lodash/sortBy';
// eslint-disable-next-line no-duplicate-imports
import Trigger from 'rc-trigger';
import KeyCode from 'rc-util/lib/KeyCode';
import arrayTreeFilter from 'array-tree-filter';
import { isEqualArrays, isIncludeArray } from './utils';
import Menus from './Menus';
import BUILT_IN_PLACEMENTS from './placements';
const getFieldNames = ({ fieldNames }) => fieldNames;
const getFilledFieldNames = (props) => {
    const fieldNames = getFieldNames(props) || {};
    const names = {
        children: fieldNames.children || 'children',
        label: fieldNames.label || 'label',
        value: fieldNames.value || 'value'
    };
    return names;
};
const flattenTree = (options, props, ancestor = []) => {
    const names = getFilledFieldNames(props);
    let flattenOptions = [];
    const childrenName = names.children;
    options.forEach(option => {
        const path = ancestor.concat(option);
        if (props.changeOnSelect || !option[childrenName] || !option[childrenName].length) {
            flattenOptions.push(path);
        }
        if (option[childrenName]) {
            flattenOptions = flattenOptions.concat(flattenTree(option[childrenName], props, path));
        }
    });
    return flattenOptions;
};
const getEnableOptions = (options) => {
    const enabledOptions = [];
    if (options && options.length) {
        options.forEach(option => {
            const { disabled, children } = option;
            if (disabled) {
                return;
            }
            if (children && children.length) {
                const enabledChilren = getEnableOptions(children);
                if (!isEmpty(enabledChilren)) {
                    enabledOptions.push(Object.assign(Object.assign({}, option), { children: enabledChilren }));
                }
                return;
            }
            enabledOptions.push(option);
        });
    }
    return enabledOptions;
};
class Cascader extends React.Component {
    constructor(props) {
        super(props);
        this.setPopupVisible = (popupVisible) => {
            const { value } = this.props;
            if (!('popupVisible' in this.props)) {
                this.setState({ popupVisible });
            }
            // sync activeValue with value when panel open
            if (popupVisible && !this.state.popupVisible && !isEmpty(value)) {
                if (this.props.mode !== 'multiple') {
                    this.setState({
                        activeValue: value
                    });
                }
                else {
                    // 展开后才能获取到options值
                    window.setTimeout(() => {
                        const totalValues = this.getTotalValues();
                        const sortedValue = sortBy(value, valueItem => {
                            return findIndex(totalValues, totalValueItem => isEqualArrays(totalValueItem, valueItem));
                        });
                        this.setState({
                            activeValue: sortedValue === null || sortedValue === void 0 ? void 0 : sortedValue[0]
                        });
                    }, 0);
                }
            }
            this.setState({ hoveredValue: [] });
            this.props.onPopupVisibleChange(popupVisible);
        };
        this.handleChange = (options, { visible }, e) => {
            if (e.type !== 'keydown' || e.keyCode === KeyCode.ENTER) {
                this.props.onChange(options.map(o => o[this.getFieldName('value')]), options);
                this.setPopupVisible(visible);
            }
        };
        this.handlePopupVisibleChange = (popupVisible) => {
            this.setPopupVisible(popupVisible);
        };
        this.handleMenuSelect = (targetOption, menuIndex, e) => {
            // Keep focused state for keyboard support
            const triggerNode = this.trigger.getRootDomNode();
            if (triggerNode && triggerNode.focus && e.type === 'click') {
                triggerNode.focus();
            }
            const { changeOnSelect, loadData, expandTrigger } = this.props;
            if (!targetOption || targetOption.disabled) {
                return;
            }
            let { activeValue } = this.state;
            activeValue = activeValue.slice(0, menuIndex + 1);
            activeValue[menuIndex] = targetOption[this.getFieldName('value')];
            const activeOptions = this.getActiveOptions(activeValue);
            if (targetOption.isLeaf === false
                && !targetOption[this.getFieldName('children')]
                && loadData) {
                if (changeOnSelect && (e.type === 'click' || e.type === 'keydown')) {
                    this.handleChange(activeOptions, { visible: true }, e);
                }
                loadData(activeOptions);
                this.setState({ activeValue });
                return;
            }
            const newState = {};
            if (!targetOption[this.getFieldName('children')]
                || !targetOption[this.getFieldName('children')].length) {
                if (this.props.mode !== 'multiple' && e.type === 'click') {
                    this.handleChange(activeOptions, { visible: false }, e);
                    // add e.type judgement to prevent `onChange` being triggered by mouseEnter
                }
            }
            else if (changeOnSelect && (e.type === 'click' || e.type === 'keydown')) {
                if (expandTrigger === 'hover') {
                    this.handleChange(activeOptions, { visible: false }, e);
                }
                else {
                    this.handleChange(activeOptions, { visible: true }, e);
                }
            }
            newState.activeValue = activeValue;
            newState.hoveredValue = activeValue;
            this.setState(newState);
        };
        this.handleMenuMultiSelect = (targetOption, _menuIndex, optionKey, e) => {
            const checked = e.target.checked;
            const targetOptionChildren = targetOption[this.getFieldName('children')];
            const { keyword, value = [] } = this.props;
            let newValue = [];
            // 1、当前有子级：将除disabled外的所有子级全部push进value
            if (targetOptionChildren && targetOptionChildren.length) {
                const enableChildren = getEnableOptions(targetOptionChildren);
                const flattenOptions = flattenTree(enableChildren, this.props);
                const childrenValue = flattenOptions.map(option => ([
                    ...optionKey,
                    ...option.map(o => o[this.getFieldName('value')])
                ]));
                newValue = checked ? [
                    ...value,
                    ...childrenValue.filter(valueItem => !isIncludeArray(value, valueItem))
                ] : value.filter(valueItem => !isIncludeArray(childrenValue, valueItem));
            }
            // 2、当前是最后一级：直接push进value
            else {
                if (checked) {
                    newValue = keyword ? [...value, ...optionKey] : [...value, optionKey];
                }
                else {
                    newValue = value.filter(valueItem => !isEqualArrays(valueItem, (keyword ? optionKey[0] : optionKey)));
                }
            }
            // 3、对newValue进行排序
            // const totalValues = this.getTotalValues();
            // let newSortedValue = [];
            // totalValues.forEach(value => {
            //     if (isIncludeArray(newValue, value)) {
            //         newSortedValue.push(value);
            //     }
            // });
            // 先取消排序
            let newSortedValue = newValue;
            const newSortedSelectOptions = newSortedValue.map(valueItem => {
                return this.getActiveOptions(valueItem, this.props.originOptions);
            });
            this.props.onChange(newSortedValue, newSortedSelectOptions);
        };
        this.handleMenuMultiSelectAll = e => {
            const checked = e.target.checked;
            const { value } = this.props;
            const disabledValues = this.getDisabledValues();
            if (checked) {
                const enableValues = this.getEnableValues();
                const disabledInValue = filter(value, valueItem => isIncludeArray(disabledValues, valueItem));
                const newValue = [...enableValues, ...disabledInValue];
                const newSelectOptions = newValue.map(valueItem => arrayTreeFilter(this.props.options || [], (o, level) => o[this.getFieldName('value')] === valueItem[level], { childrenKeyName: this.getFieldName('children') }));
                this.props.onChange(newValue, newSelectOptions);
                this.setState({ activeValue: [] });
                this.setPopupVisible(false);
            }
            else {
                const newValue = value.filter(valueItem => isIncludeArray(disabledValues, valueItem));
                const newSelectOptions = newValue.map(valueItem => this.getActiveOptions(valueItem));
                this.props.onChange(newValue, newSelectOptions);
                this.setState({ activeValue: [] });
            }
        };
        this.handleActiveValueSet = activeValue => {
            this.setState(prevState => (Object.assign(Object.assign({}, prevState), { activeValue })));
        };
        this.handleItemDoubleClick = () => {
            const { changeOnSelect } = this.props;
            if (changeOnSelect) {
                this.setPopupVisible(false);
            }
        };
        this.handleKeyDown = (e) => {
            const { children } = this.props;
            // Don't bind keyboard support when children specify the onKeyDown
            if (children && children.props.onKeyDown) {
                children.props.onKeyDown(e);
                return;
            }
            const activeValue = [...this.state.activeValue];
            const currentLevel = activeValue.length - 1 < 0 ? 0 : activeValue.length - 1;
            const currentOptions = this.getCurrentLevelOptions();
            const currentIndex = currentOptions
                .map(o => o[this.getFieldName('value')])
                .indexOf(activeValue[currentLevel]);
            if (e.keyCode !== KeyCode.DOWN
                && e.keyCode !== KeyCode.UP
                && e.keyCode !== KeyCode.LEFT
                && e.keyCode !== KeyCode.RIGHT
                && e.keyCode !== KeyCode.ENTER
                && e.keyCode !== KeyCode.SPACE
                && e.keyCode !== KeyCode.BACKSPACE
                && e.keyCode !== KeyCode.ESC
                && e.keyCode !== KeyCode.TAB) {
                return;
            }
            // Press any keys above to reopen menu
            if (!this.state.popupVisible
                && e.keyCode !== KeyCode.BACKSPACE
                && e.keyCode !== KeyCode.LEFT
                && e.keyCode !== KeyCode.RIGHT
                && e.keyCode !== KeyCode.ESC
                && e.keyCode !== KeyCode.TAB) {
                this.setPopupVisible(true);
                if (this.props.onKeyDown) {
                    this.props.onKeyDown(e);
                }
                return;
            }
            if (e.keyCode === KeyCode.DOWN || e.keyCode === KeyCode.UP) {
                e.preventDefault();
                let nextIndex = currentIndex;
                if (nextIndex !== -1) {
                    if (e.keyCode === KeyCode.DOWN) {
                        nextIndex += 1;
                        nextIndex = nextIndex >= currentOptions.length ? 0 : nextIndex;
                    }
                    else {
                        nextIndex -= 1;
                        nextIndex = nextIndex < 0 ? currentOptions.length - 1 : nextIndex;
                    }
                }
                else {
                    nextIndex = 0;
                }
                activeValue[currentLevel]
                    = currentOptions[nextIndex][this.getFieldName('value')];
            }
            else if (e.keyCode === KeyCode.LEFT
                || e.keyCode === KeyCode.BACKSPACE) {
                e.preventDefault();
                activeValue.splice(activeValue.length - 1, 1);
            }
            else if (e.keyCode === KeyCode.RIGHT) {
                e.preventDefault();
                if (currentOptions[currentIndex]
                    && currentOptions[currentIndex][this.getFieldName('children')]) {
                    activeValue.push(currentOptions[currentIndex][this.getFieldName('children')][0][this.getFieldName('value')]);
                }
            }
            else if (e.keyCode === KeyCode.ESC || e.keyCode === KeyCode.TAB) {
                this.setPopupVisible(false);
                if (this.props.onKeyDown) {
                    this.props.onKeyDown(e);
                }
                return;
            }
            if (!activeValue || activeValue.length === 0) {
                this.setPopupVisible(false);
            }
            const activeOptions = this.getActiveOptions(activeValue);
            const targetOption = activeOptions[activeOptions.length - 1];
            this.handleMenuSelect(targetOption, activeOptions.length - 1, e);
            if (this.props.onKeyDown) {
                this.props.onKeyDown(e);
            }
        };
        this.saveTrigger = node => {
            this.trigger = node;
        };
        let initialValue = [];
        if ('value' in props) {
            initialValue = props.value || [];
        }
        else if ('defaultValue' in props) {
            initialValue = props.defaultValue || [];
        }
        this.state = {
            popupVisible: props.popupVisible,
            activeValue: props.initialActiveValue || initialValue,
            hoveredValue: [],
            prevProps: props
        };
        this.defaultFieldNames = {
            label: 'label',
            value: 'value',
            children: 'children'
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { prevProps = {} } = prevState;
        const newState = {
            prevProps: nextProps
        };
        if ('value' in nextProps && !isEqualArrays(prevProps.value, nextProps.value)) {
            // allow activeValue diff from value
            if (!('loadData' in nextProps) && nextProps.mode !== 'multiple') {
                newState.activeValue = (nextProps.value || []);
            }
        }
        if ('popupVisible' in nextProps) {
            newState.popupVisible = nextProps.popupVisible;
        }
        return newState;
    }
    getPopupDOMNode() {
        return this.trigger.getPopupDomNode();
    }
    getFieldName(name) {
        return this.props.fieldNames[name] || this.defaultFieldNames[name];
    }
    getFieldNames() {
        return this.props.fieldNames;
    }
    getActiveOptions(activeValue, options) {
        return arrayTreeFilter(options || this.props.options || [], (o, level) => o[this.getFieldName('value')] === activeValue[level], { childrenKeyName: this.getFieldName('children') });
    }
    getCurrentLevelOptions() {
        const { options = [] } = this.props;
        const { activeValue = [] } = this.state;
        const result = this.getActiveOptions(activeValue);
        if (result[result.length - 2]) {
            return result[result.length - 2][this.getFieldName('children')];
        }
        return [...options].filter(o => !o.disabled);
    }
    getTotalValues(options) {
        const flattenOptions = flattenTree(options || this.props.options, this.props);
        return flattenOptions.map(option => option.map(o => {
            const value = o[this.getFieldName('value')];
            return this.props.keyword ? value[0] : value;
        }));
    }
    getEnableValues(options) {
        const enableOptions = getEnableOptions(options || this.props.options);
        const flattenOptions = flattenTree(enableOptions, this.props);
        return flattenOptions.map(option => option.map(o => o[this.getFieldName('value')]));
    }
    getDisabledValues() {
        const flattenOptions = flattenTree(this.props.options, this.props);
        const disabledOptions = flattenOptions.filter(options => {
            return options.some(option => option.disabled);
        });
        return disabledOptions.map(options => options.map(o => o[this.getFieldName('value')]));
    }
    render() {
        const _a = this.props, { prefixCls, transitionName, popupClassName, options = [], disabled, builtinPlacements, popupPlacement, children, dropdownRender } = _a, restProps = __rest(_a, ["prefixCls", "transitionName", "popupClassName", "options", "disabled", "builtinPlacements", "popupPlacement", "children", "dropdownRender"]);
        // Did not show popup when there is no options
        let menus = <div />;
        let emptyMenuClassName = '';
        if (options && options.length > 0) {
            menus = (<Menus {...this.props} fieldNames={this.getFieldNames()} defaultFieldNames={this.defaultFieldNames} visible={this.state.popupVisible} activeValue={this.state.activeValue} hoveredValue={this.state.hoveredValue} enableValues={this.getEnableValues()} getEnableValues={this.getEnableValues} totalValues={this.getTotalValues()} getTotalValues={this.getTotalValues} onActiveValueSet={this.handleActiveValueSet} onSelect={this.handleMenuSelect} onMultiSelect={this.handleMenuMultiSelect} onMultiSelectAll={this.handleMenuMultiSelectAll} onItemDoubleClick={this.handleItemDoubleClick}/>);
        }
        else {
            emptyMenuClassName = ` ${prefixCls}-menus-empty`;
        }
        let popupNode = menus;
        if (dropdownRender) {
            popupNode = dropdownRender(menus);
        }
        return (<Trigger ref={this.saveTrigger} {...restProps} popupPlacement={popupPlacement} builtinPlacements={builtinPlacements} popupTransitionName={transitionName} action={disabled ? [] : ['click']} popupVisible={disabled ? false : this.state.popupVisible} onPopupVisibleChange={this.handlePopupVisibleChange} prefixCls={`${prefixCls}-menus`} popupClassName={popupClassName + emptyMenuClassName} popup={popupNode}>
                {React.cloneElement(children, {
                onKeyDown: this.handleKeyDown,
                tabIndex: disabled ? undefined : 0
            })}
            </Trigger>);
    }
}
Cascader.defaultProps = {
    onChange: () => { },
    onPopupVisibleChange: () => { },
    disabled: false,
    transitionName: '',
    prefixCls: 'rc-cascader',
    popupClassName: '',
    popupPlacement: 'bottomLeft',
    builtinPlacements: BUILT_IN_PLACEMENTS,
    expandTrigger: 'hover',
    fieldNames: { label: 'label', value: 'value', children: 'children' },
    expandIcon: '>'
};
export default Cascader;
